/**
 * Kata pengisi GPT-Live (#59 latensi): transkrip suara GPT-Live antara ucapan
 * user dan kalimat jawaban pertama dari Claude. Ditampilkan sebagai baris
 * abu-abu kecil di panel suara — bukan bubble jawaban, tidak masuk riwayat.
 */

import { joinTranscript } from "./voice-transcript";

export interface FillerTracker {
	/** User mulai bicara: buka jendela pengisi baru (pengisi lama dihapus). */
	open(): void;
	/** Potongan transkrip suara GPT-Live. */
	output(delta: string): void;
	/** Jawaban (atau pesan kosong/gagal) mulai dikirim: ucapan berikutnya bukan pengisi. */
	close(): void;
	/** Giliran selesai: hapus baris pengisi. */
	clear(): void;
}

export function createFillerTracker(
	emit: (text: string) => void,
): FillerTracker {
	let open = false;
	let text = "";
	const set = (next: string) => {
		if (next === text) return;
		text = next;
		emit(text);
	};
	return {
		open() {
			open = true;
			set("");
		},
		output(delta) {
			if (open) set(joinTranscript(text, delta));
		},
		close() {
			open = false;
		},
		clear() {
			open = false;
			set("");
		},
	};
}
